import { Injectable } from "@angular/core";

import { SocketService } from "../socket.service";
import { DestructorService } from "@core-services/destructor.service";
import { TranslationService } from "@core-services/translation.service";
import { InitService } from "@core-services/init.service";
import { debug } from "@helpers/debug";
import { DerivativeService } from "./derivative.service";
import { Etf } from "@models/derivative/currencies/etf";

@Injectable({
	providedIn: "root"
})
export class EtfService extends DerivativeService<Etf> {
	public constructor(
		protected initService: InitService,
		protected socketService: SocketService,
		protected translationService: TranslationService,
		protected destructor: DestructorService
	) {
		super(initService, destructor, translationService, socketService, "EtfService");
	}

	public logoUrl(item: Etf, grayVersion: boolean = false): string {
		let url = "assets/images/logos/";

		if (grayVersion) {
			url += "etfs/" + item.getSymbol(true) + "-grey-half-transparent";
		} else {
			url += "etfs/etfs-" + item.getSymbol(true);
		}

		return url;
	}

	public startSockets(): void {
		if (debug) {
			console.log("[DEBUG]: listen to etf updates");
		}

		const priceRoom = {
			room: "etf_prices",
			collection: "etfs",
			type: Etf,
			isPrivate: false
		};
		const tradableRoom = {
			room: "etfs",
			collection: "etfs",
			type: Etf,
			isPrivate: false
		};
		this.initSockets(priceRoom, tradableRoom);
	}
}
